<template lang="pug">
.app-image-uploader
  img.avatar.avatar-thumb.processing.image-preview(
    v-if="placeholder || safeFileUrl"
    :src="safeFileUrl"
  )

  AppFilePicker.upload(
    ref="filePicker"
    name="upload"
    :accept="acceptedTypes"
    :show-label="showLabel"
    @input="uploadPreview"
  )
    template(slot="uploadText")
      slot(name="uploadText")
</template>

<script>
import { RECEIPT_ICON } from '~/rails_assets';

export default {
  name: 'AppImageUploader',
  props: {
    showLabel: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: Boolean,
      default: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
    acceptedFileTypes: {
      type: Array,
      default() {
        return ['.jpeg', '.jpg', '.gif', '.png', '.svg', '.tiff'];
      },
    },
    fileUrl: {
      type: String,
    },
  },
  computed: {
    safeFileUrl() {
      if (this.placeholder && !this.fileUrl) {
        return RECEIPT_ICON;
      }

      return this.fileUrl;
    },
    acceptedTypes() {
      return this.acceptedFileTypes ? this.acceptedFileTypes.join(', ') : '';
    },
  },
  watch: {
    loading(status) {
      $(this.$el).loadingCurtain(status ? 'show' : 'hide');
    },
  },
  methods: {
    uploadPreview(file) {
      if (file) {
        this.$emit('start-uploading', file);
      }
    },
  },
};
</script>
